module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppjusticedamned0006#toc"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "ep"
  }, [_vm._v("Whether it makes one cry or sing,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("justice must be carried out.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—Marie de France, c. 1170, “Lanval,”"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("l. 437-8 (translator unknown)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6341a966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-justicedamned0004.vue
// module id = 66
// module chunks = 0